module.exports = __webpack_public_path__ + "static/step-4-6f110823818520415700bc9b18e83217.png";